// extracted by css-extract-rspack-plugin
export default {"viewer":"content-editor-core-viewer-viewer-viewer-1128caf3"};